/**
 * ThemeIcon Component
 *
 * A themed wrapper around Mantine's ThemeIcon component.
 * Renders an icon inside a themed container with background color.
 */

import { ThemeIcon as MantineThemeIcon, ThemeIconProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedThemeIconProps extends ThemeIconProps {}

const ThemeIcon = forwardRef<HTMLDivElement, ThemedThemeIconProps>((props, ref) => (
  <MantineThemeIcon ref={ref} {...props} />
));

ThemeIcon.displayName = 'ThemeIcon';

export default ThemeIcon;
